import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SsoAuthService } from '../../sso-auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-registration',
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './registration.html',
  styleUrl: './registration.scss'
})
export class Registration {
  securityStep = 1;
  securityForm!: FormGroup;
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
  isLoading = false;
  otp: string = '';
  otpError: string = '';
  countdown: number = 60;
  otpRequestId: string = '';
  showOtp: boolean = false
  constructor(
    private fb: FormBuilder,
    private authService: SsoAuthService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.securityForm = this.fb.group({
      fcSecurityForm: ['', [Validators.required, Validators.minLength(12)]],
      nameAsPerAP: ['', [Validators.required]],
      ritwikName: ['', [Validators.required]],
      dpSerialNo: [''],
      arghyaSerialNo: [''],
      contactNo: ['', Validators.required],
    });
  }

  // restrict FC Input from wrong chars
  restrictFCInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /[0-9]/;

    if (this.allowedKeys.includes(input) || event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 11) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }

  // reestrict AP Serial from wrong chars
  restrictAPSerialInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /[0-9]/;

    if (this.allowedKeys.includes(input) || event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 17) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }

  onSerialChange(changedField: 'arghyaSerialNo' | 'dpSerialNo') {
    const arghyaControl = this.securityForm.get('arghyaSerialNo');
    const dpControl = this.securityForm.get('dpSerialNo');

    if (changedField === 'arghyaSerialNo' && arghyaControl?.value?.trim()) {
      dpControl?.setValue('');
    } else if (changedField === 'dpSerialNo' && dpControl?.value?.trim()) {
      arghyaControl?.setValue('');
    }
  }
  // start countdown
  startCountdown() {
    this.countdown = 60;
    const interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(interval);
      }
    }, 1000);
  }
  nextSecurityStep() {

    if (this.securityStep === 1) {
      const fcControl = this.securityForm.get('fcSecurityForm');
      const nameControl = this.securityForm.get('nameAsPerAP');
      const contactControl = this.securityForm.get('contactNo');

      if (fcControl?.invalid || nameControl?.invalid || contactControl?.invalid) {
        fcControl?.markAsTouched();
        nameControl?.markAsTouched();
        contactControl?.markAllAsTouched();
        return;
      }
      const payload = {
        name: this.securityForm.get('nameAsPerAP')?.value,
        fc: this.securityForm.get('fcSecurityForm')?.value,
        contactNo: this.securityForm.get('contactNo')?.value,
        step: 1
      };

      this.isLoading = true

      this.authService.register(payload).subscribe({
        next: (res: any) => {
          if (res?.data?.stateToken) {
            sessionStorage.setItem('state_token', res.data.stateToken);
          }
          this.securityStep++;
          this.isLoading = false
        },
        error: (err: any) => {
          this.toastr.error(err?.message || 'Something went wrong');
          this.isLoading = false
        }
      });
    }

    if (this.securityStep === 2) {
      const ritwikControl = this.securityForm.get('ritwikName');

      if (ritwikControl?.invalid) {
        ritwikControl?.markAsTouched();
        return;
      }

      const payload = {
        ritwikName: ritwikControl?.value,
        step: 2
      };

      this.isLoading = true;

      this.authService.register(payload).subscribe({
        next: (res: any) => {
          if (res?.data?.stateToken) {
            sessionStorage.setItem('state_token', res.data.stateToken);
          }
          this.securityStep++;
          this.isLoading = false;
        },
        error: (err: any) => {
          this.toastr.error(err?.message || 'Something went wrong');
          this.isLoading = false;
        }
      });
    }



    if (this.securityStep === 3) {
      const arghyaVal = this.securityForm.get('arghyaSerialNo')?.value?.trim();
      const dpVal = this.securityForm.get('dpSerialNo')?.value?.trim();

      if (!arghyaVal && !dpVal) {
        this.toastr.error('Please enter either Arghya Praswasti Serial No or Dikshya Patra Serial No');
        this.securityForm.get('arghyaSerialNo')?.markAsTouched();
        this.securityForm.get('dpSerialNo')?.markAsTouched();
        return;
      }

      const payload: any = { step: 3 };
      if (arghyaVal) payload.apSerialNo = arghyaVal;
      if (dpVal) payload.serialNo = Number(dpVal);

      this.isLoading = true;

      this.authService.register(payload).subscribe({
        next: (res: any) => {
          console.log("token", res?.data?.stateToken)
          if (res?.data?.stateToken) {
            sessionStorage.setItem('state_token_2', res.data.stateToken);
          }
          if (res?.data?.otpRequestId) {
            this.otpRequestId = res?.data?.otpRequestId;
            this.startCountdown()
            this.otpError = ''
            this.securityStep++;
          }
          else {
            this.toastr.error('Something went wrong');
          }

          this.isLoading = false;
        },
        error: (err: any) => {
          this.toastr.error(err?.message || 'Something went wrong');
          this.isLoading = false;
        },
      });
    }




    // if (this.securityStep < 4) {
    //   this.securityStep++;
    // }
  }

  isNextDisabled(): boolean {
    if (!this.securityForm || this.isLoading) return true;


    switch (this.securityStep) {
      case 1:
        return !!(
          this.securityForm.get('fcSecurityForm')?.invalid ||
          this.securityForm.get('nameAsPerAP')?.invalid
        );
      case 2:
        return !!this.securityForm.get('dpSerialNo')?.invalid;
      case 3:
        const arghyaVal = this.securityForm.get('arghyaSerialNo')?.value?.trim();
        const dpVal = this.securityForm.get('dpSerialNo')?.value?.trim();
        return !(arghyaVal || dpVal);
      default:
        return false;
    }
  }

  cancelSecurityFlow() {
    this.securityForm.reset();
    this.securityStep = 1;
    this.router.navigate([''])
  }

  validateOtp() {
    if (!this.otp) {
      this.otpError = 'OTP is required';
      return false;
    } else if (!/^\d+$/.test(this.otp)) {
      this.otpError = 'OTP must contain only numbers';
      return false;
    } else if (this.otp.length !== 6) {
      this.otpError = 'OTP must be exactly 6 digits';
      return false;
    } else {
      this.otpError = '';
      return true;
    }
  }

  // allow only digits to be entered
  allowOnlyDigits(event: KeyboardEvent): void {
    const key = event.key;
    // Allow digits 0-9, and also allow special keys like Backspace, Tab, Arrow keys, etc.
    if (!/^\d$/.test(key) && !this.allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }

  resendOTP() {
    this.otp = '';
    this.otpError = '';
    this.otpRequestId = '';
    this.securityStep--;
    this.nextSecurityStep();
  }


  verifyOtp() {
    // const appId = sessionStorage.getItem('sso_appId');
    // const codeChallenge = sessionStorage.getItem('sso_codeChallenge');

    if (!this.otpRequestId || !this.validateOtp()) return;

    const payload: any = {
      id: parseInt(this.otpRequestId),
      otp: this.otp,
    };

    // const appId = sessionStorage.getItem('sso_appId');
    // const codeChallenge = sessionStorage.getItem('sso_codeChallenge');

    // if (appId && appId !== 'null' && appId !== 'undefined') {
    //   payload.appId = Number(appId);
    // }

    // if (codeChallenge && codeChallenge !== 'null' && codeChallenge !== 'undefined') {
    //   payload.codeChallenge = codeChallenge;
    // }

    this.isLoading = true;
    this.authService.verifyOtpRegister(payload).subscribe({
      next: (res: any) => {
        console.log(res);
        this.isLoading = false;
        this.toastr.success(res.message || 'Successfully registered');
        this.router.navigate([''], { queryParamsHandling: 'merge' })
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error verifying OTP:', err);
        const errorMsg = err?.message || 'Something went wrong. Please try again.';
        this.toastr.error(errorMsg);
        this.isLoading = false;
      },
    });
  }
}
